export const browserNavigation = {
  assign(url: string): void {
    window.location.assign(url);
  },

  reload(): void {
    window.location.reload();
  },
};
